import { useTranslation } from "react-i18next";
import formatPrice from "@/core/helpers/formatPrice";
import { CartIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";

type Props = {
  totalCount: number;
  totalPrice: number;
  setIsCart: (arg0: boolean) => void;
};

export default function GoodsAndWarehouseFooter({ totalCount, totalPrice, setIsCart }: Props) {
  const { t } = useTranslation("business");

  return (
    <div className="w-full min-h-[4.625rem]">
      <div className="size-full flex justify-between px-7.5 bg-gradient-to-b from-dark-900/15 to-[#0164AC]/15">
        <div>
          <p className="mb-1.5 text-20 font-bold text-accent-solid">{formatPrice(totalPrice)}₽</p>
          <p className="text-15 font-medium">{t("business.goodsAndWarehouse.summInCart")}</p>
        </div>
        <Button
          onClick={() => setIsCart(true)}
          className="justify-between gap-2.5 w-50 h-11 py-[0.875rem] pl-3.5 pr-[0.69rem] font-bold rounded-xl bg-accent-muted/20 hover:brightness-110"
          variant="solid"
        >
          <div className="flex items-center gap-2.5">
            <CartIcon className="size-4.5 text-accent-solid" />
            <p className="leading-none">{t("business.goodsAndWarehouse.cart")}</p>
          </div>
          <p className="px-1.5 py-2 leading-none rounded-lg bg-accent-solid/20">{totalCount}</p>
        </Button>
      </div>
    </div>
  );
}
